import { useMemo, useState } from "react";
import STBoardComments from "../../../assets/styles/organisms/boardComment.module.scss";
import Comment from "./Comment";
import {
  useGetAllRepliesCommentByParentId,
  useConvertCommentTree,
} from "./hooks";
import moment from "moment";
import { useBoard } from "../../../providers/BoardDetailProvider";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const DEFAUT_REPLIES_COMMENT_SHOW = 5;

const RepliesComment = (props: any) => {
  const { isLoadingReplies, handleGetAllReplies } =
    useGetAllRepliesCommentByParentId();
  const { repliesComment = [], parentId, totalRepliesComment } = props;
  const repliesCommentLength = repliesComment.length;
  const [showAllRepliesComments, setShowAllRepliesComment] = useState<boolean>(
    repliesCommentLength >= totalRepliesComment
  );
  const onShowAllRepliesComment = async () => {
    if (totalRepliesComment - repliesCommentLength !== 0) {
      await handleGetAllReplies(
        Number(parentId),
        Number(totalRepliesComment + repliesCommentLength)
      );
    }
    setShowAllRepliesComment(true);
  };

  const onCollapseRepliesComment = () => setShowAllRepliesComment(false);

  const showTotalReplies = useMemo(() => {
    if (!!showAllRepliesComments) {
      return totalRepliesComment + repliesCommentLength;
    }

    if (totalRepliesComment === repliesCommentLength) {
      return DEFAUT_REPLIES_COMMENT_SHOW;
    }

    return Math.max(repliesCommentLength, DEFAUT_REPLIES_COMMENT_SHOW);
  }, [repliesCommentLength, showAllRepliesComments, totalRepliesComment]);

  const countRepliesComment = useMemo(() => {
    if (totalRepliesComment - repliesCommentLength !== 0) {
      return totalRepliesComment - repliesCommentLength;
    }

    return totalRepliesComment - DEFAUT_REPLIES_COMMENT_SHOW;
  }, [repliesCommentLength, totalRepliesComment]);

  if (isLoadingReplies) {
    return null;
  }
  return (
    <div className={STBoardComments.newCommentReplies}>
      {repliesComment.slice(0, showTotalReplies)?.map((e: any) => {
        return <Comment key={`reply_item_${e?.id}`} data={e} isRoot={false} />;
      })}
      {
        <>
          {!showAllRepliesComments && countRepliesComment > 0 && (
            <div
              className={STBoardComments.showAllRepliesComment}
              onClick={onShowAllRepliesComment}
            >
              <KeyboardArrowDownIcon />
              <span>{`返信をもっと見る(${countRepliesComment})`}</span>
            </div>
          )}
          {showAllRepliesComments &&
            repliesCommentLength > DEFAUT_REPLIES_COMMENT_SHOW && (
              <div
                className={STBoardComments.showAllRepliesComment}
                onClick={onCollapseRepliesComment}
              >
                <KeyboardArrowUpIcon />
                <span>閉じる</span>
              </div>
            )}
        </>
      }
    </div>
  );
};

const CommentsList = () => {
  const {
    state: { comments },
  } = useBoard();
  const convertCommentTree = useConvertCommentTree();
  return (
    <div className={STBoardComments.commentWrapper}>
      {Object.entries(convertCommentTree(comments))
        .sort(([_, a], [__, b]) => {
          const commentA = a as any;
          const commentB = b as any;
          const pinnedComparison =
            Number(!!commentB.is_pinned) - Number(commentA?.is_pinned);
          if (pinnedComparison !== 0) return pinnedComparison;
          return (
            moment(commentB?.created_at).valueOf() -
            moment(commentA?.created_at).valueOf()
          );
        })
        .map(([_, element]: [any, any]) => {
          const { children = [], total_reply_comments = 0, id } = element;
          const hasChild = !!total_reply_comments || !!children.length;
          return (
            <div
              key={`parent_${id}`}
              className={STBoardComments.newCommentElementContainer}
            >
              <Comment data={element} isRoot={true} />
              <div
                className={hasChild ? STBoardComments.newCommentReplies : ""}
              >
                {hasChild && (
                  <RepliesComment
                    repliesComment={children}
                    parentId={id}
                    totalRepliesComment={total_reply_comments}
                  />
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default CommentsList;
